export const iconFontAwesomeLogisticsCarTunnel = (
	<i className="fa-solid fa-car-tunnel"></i>
);
